import { createApiService } from "@/core/api/apiService";
import type {
  CreateServiceDto,
  ReorderServicesDto,
  ServiceDto,
  UpdateServiceDto,
} from "../types/serviceTypes";

export function createServiceApiService() {
  const api = createApiService("services");
  const businessApi = createApiService("businesses");

  return {
    getAll: async (businessId: string, signal?: AbortSignal): Promise<ServiceDto[]> => {
      return api.get<ServiceDto[]>(`/?businessId=${businessId}`, { signal });
    },

    getActive: async (businessId: string): Promise<ServiceDto[]> => {
      return api.get<ServiceDto[]>(`/?businessId=${businessId}&isActive=true`);
    },

    getById: async (id: string): Promise<ServiceDto> => {
      return api.get<ServiceDto>(`/${id}`);
    },

    create: async (data: CreateServiceDto): Promise<ServiceDto> => {
      return api.post<ServiceDto>("", data);
    },

    update: async (id: string, data: UpdateServiceDto): Promise<ServiceDto> => {
      return api.put<ServiceDto>(`/${id}`, data);
    },

    reorder: async (businessId: string, data: ReorderServicesDto): Promise<ServiceDto[]> => {
      return businessApi.put<ServiceDto[]>(`/${businessId}/services/reorder`, data);
    },

    delete: async (id: string): Promise<{ message: string }> => {
      return api.delete<{ message: string }>(`/${id}`);
    },
  };
}

const serviceApiService = createServiceApiService();
export { serviceApiService };
